import { EditButton, Show } from "@refinedev/antd";
import { IResourceComponentsProps, useParsed, useShow } from "@refinedev/core";
import { Divider, Typography } from "antd";
import { COLOR_PRIMARY_ORANGE } from "theme/colors";

export const DocumentShow: React.FC<IResourceComponentsProps> = () => {
  const { id } = useParsed();

  const { queryResult } = useShow({
    resource: "document",
    id
  });
  const { data, isLoading } = queryResult;
  const document = data?.data;

  return (
    <Show
      resource="document"
      isLoading={isLoading}
      headerProps={{
        title: "Documents"
      }}
      breadcrumb={false}
      headerButtons={({ deleteButtonProps, editButtonProps }) => {
        return (
          <>
            <EditButton
              {...editButtonProps}
              style={{
                border: "none",
                backgroundColor: COLOR_PRIMARY_ORANGE
              }}>
              Edit
            </EditButton>
          </>
        );
      }}>
      <Typography.Title>{document?.title}</Typography.Title>
      <Divider />
      <div
        style={{ overflow: "auto" }}
        dangerouslySetInnerHTML={{ __html: document?.content || "" }}
      />
    </Show>
  );
};
